export default "__VITE_ASSET___aWz9RFu__"